'use client';

import { ReactNode } from 'react';

import { useRetainableSearchParamsContext } from '@preventx/prismic-services';

// Configuration
import { referrers } from '@/configuration/referrers';

type AdvertisementType = 'Default' | 'Discount' | 'Promotion';

type AdvertisementListenerProps = {
  children: ReactNode;
  type: AdvertisementType;
};

export const AdvertisementListener = ({
  type,
  children,
}: AdvertisementListenerProps) => {
  const { searchParams, isInitialised } = useRetainableSearchParamsContext();

  // Purpose    :   To avoid content being rendered where it shouldn't (even as an initial flash) wait
  //                until the page has finished rendering before carrying on with the trigger
  if (!isInitialised) {
    return null;
  }

  if (type === 'Default' && searchParams.length === 0) {
    return <>{children}</>;
  }

  const referrer = searchParams.find(({ key }) => key === 'ref');

  if (!referrer) {
    return <>{children}</>;
  }

  const matchedReferrer = referrers.find(({ uid }) => uid === referrer.value);

  if (!matchedReferrer) {
    return <>{children}</>;
  }

  const { suppressDiscounts, suppressPromotions } = matchedReferrer;

  const isSupressed =
    (type === 'Promotion' && suppressPromotions) ||
    (type === 'Discount' && suppressDiscounts);

  if (isSupressed) {
    return null;
  }

  return <>{children}</>;
};
